<template>
    <div class="avue-logo" @click="setCollapse">
        <transition name="fade">
            <span v-if="keyCollapse" class="avue-logo_subtitle" key="0">
                <!-- {{website.logo}} -->
                <svg-icon icon-class="logo_x1" class="icon" />
            </span>
        </transition>
        <transition-group name="fade">
            <template v-if="!keyCollapse">
                <!-- <span class="avue-logo_title" key="1">{{website.indexTitle}} </span> -->
                <span class="avue-logo_title" key="1">
                    <svg-icon icon-class="logo_d1" class="icon" />
                </span>
            </template>
        </transition-group>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: "logo",
    data() {
        return {};
    },
    created() {},
    computed: {
        ...mapGetters(["website", "keyCollapse"])
    },
    methods: {
        setCollapse() {
            this.$store.commit("SET_COLLAPSE");
        },
    }
};

</script>
<style lang="scss">
.fade-leave-active {
    transition: opacity 0.2s;
}

.fade-enter-active {
    transition: opacity 2.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.avue-logo {
    position: fixed;
    top: 0;
    left: 0;
    width: 240px;
    height: 100px;
    line-height: 64px;
    background-color: #20222a;
    font-size: 20px;
    overflow: hidden;
    box-sizing: border-box;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
    color: rgba(255, 255, 255, 0.8);
    z-index: 1024;

    &_title {
        display: block;
        text-align: center;
        font-weight: 300;
        font-size: 20px;
    }

    &_subtitle {
        display: block;
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        color: #fff;
    }
}

.avue-logo_title {
    .icon {
        margin-top: -23px;
        font-size: 150px;
    }
}

</style>
